module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "async",
      rawName: "v-async",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "header-action"
  }, [_c('div', {
    staticClass: "form-group search"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "content-grey"
  }, [_c('p', {
    staticClass: "bold no-margin"
  }, [_vm._v("Validade")]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "row-dates"
  }, [_c('div', {
    staticClass: "form-group col-6"
  }, [_c('label', {
    attrs: {
      "for": "dataInicioViagem"
    }
  }, [_vm._v("Início da viagem")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataInicioViagem),
      expression: "dataInicioViagem"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "dataInicioViagem",
      "type": "datetime-local",
      "min": _vm.minDate,
      "max": _vm.dataFimViagem,
      "placeholder": "YYYY-MM-DDTHH:MM"
    },
    domProps: {
      "value": (_vm.dataInicioViagem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataInicioViagem = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group  col-6"
  }, [_c('label', {
    attrs: {
      "for": "dataFimViagem"
    }
  }, [_vm._v("Fim da viagem")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dataFimViagem),
      expression: "dataFimViagem"
    }],
    staticClass: "form-control small",
    attrs: {
      "name": "dataFimViagem",
      "type": "datetime-local",
      "min": _vm.dataInicioViagem,
      "max": _vm.maxDate,
      "placeholder": "YYYY-MM-DDTHH:MM"
    },
    domProps: {
      "value": (_vm.dataFimViagem)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.dataFimViagem = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('hr', {
    staticClass: "h-rule-side-yellow"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group search"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control upper",
    attrs: {
      "placeholder": "Informe o nome da rota",
      "type": "text",
      "name": "search-route"
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.searchRoutes.apply(null, arguments)
      },
      "keyup": _vm.filter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "icon-search-input",
    on: {
      "click": _vm.searchRoutes
    }
  })])])])])]), _vm._v(" "), (_vm.showAlert && !_vm.routeSelected) ? _c('div', {
    staticClass: "content-box margin-b20"
  }, [_c('div', {
    staticClass: "alert alert-info alert-container",
    class: _vm.warning && 'alert-warning'
  }, [_c('p', {
    staticClass: "no-margin"
  }, [_c('strong', [_vm._v(_vm._s(_vm.msgStrong))]), _vm._v("\n          " + _vm._s(_vm.msgAlert) + "\n        ")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_c('i', {
    staticClass: "icon-cross icon-close-modal",
    class: _vm.warning && 'icon-warning'
  })])])]) : _vm._e(), _vm._v(" "), (_vm.routes && _vm.routes.length > 0 || _vm.routeSelected) ? _c('div', {
    staticClass: "content-box-npadd table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.routesPaged), function(r) {
    return _c('tr', {
      key: r.routeId
    }, [_c('td', [_c('div', {
      staticClass: "methods-rbox"
    }, [_c('div', {
      staticClass: "radio-blue category"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.routeSelected),
        expression: "routeSelected"
      }],
      staticClass: "radiobtn",
      attrs: {
        "id": r.routeId,
        "type": "radio",
        "name": "radio"
      },
      domProps: {
        "value": r.routeId,
        "checked": _vm._q(_vm.routeSelected, r.routeId)
      },
      on: {
        "change": function($event) {
          _vm.routeSelected = r.routeId
        }
      }
    }), _vm._v(" "), _c('label', {
      staticClass: "radio-label label-h4",
      attrs: {
        "for": r.routeId
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "check first"
    })])])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.name) + " - v." + _vm._s(r.version))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAddress(r, 'origin')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.getAddress(r, 'destination')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(r.totalDistance) + " KM")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(r.tollFees.length))])])
  }), 0)])]) : _vm._e(), _vm._v(" "), (_vm.routesPaged != undefined && _vm.routesPaged.length != 0) ? [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 text-center"
  }, [_c('pagination', {
    attrs: {
      "model": _vm.page
    },
    on: {
      "page-change": _vm.setCurrentPage
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 result-table-count text-center"
  }, [_vm._v("\n          Mostrando resultados de " + _vm._s(_vm.page.firstIndexShown()) + " a " + _vm._s(_vm.page.lastIndexShown()) + " de um total de " + _vm._s(_vm.page.itemCount()) + " encontrados.\n        ")])])] : _vm._e(), _vm._v(" "), (_vm.aggregate) ? _c('div', {
    staticClass: "content-box-rounded desk margin-t50"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v(_vm._s(_vm.aggregate.companyName))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.aggregate.plate))]), _vm._v(" "), _c('td', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.aggregate.tagSerialNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.aggregate.category))])])])])]) : _vm._e(), _vm._v(" "), (_vm.aggregate) ? _c('div', {
    staticClass: "content-box-rounded mob"
  }, [(_vm.aggregate.companyName) ? _c('p', [_vm._v(_vm._s(_vm.aggregate.companyName))]) : _c('p', [_vm._v(_vm._s(_vm.aggregate.personName + ' ' + _vm.aggregate.personLastName))]), _vm._v(" "), _c('div', {}, [_c('p', [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Placa")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    directives: [{
      name: "mask-plate",
      rawName: "v-mask-plate"
    }]
  }, [_vm._v(_vm._s(_vm.aggregate.plate))])]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("TAG Nº")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.aggregate.tagSerialNumber) + "\n        ")]), _vm._v(" "), _c('p', [_c('span', {
    staticClass: "bold-600"
  }, [_vm._v("Eixos")]), _vm._v(" "), _c('br'), _vm._v("\n          " + _vm._s(_vm.aggregate.category) + "\n        ")])])]) : _vm._e()], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_c('i', {
    staticClass: "icon-info",
    attrs: {
      "data-toggle": "tooltip",
      "data-placement": "bottom",
      "title": "A validade é o período em dias que o transportador terá para realizar a viagem."
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', [_vm._v("Rota")]), _vm._v(" "), _c('th', [_vm._v("Origem")]), _vm._v(" "), _c('th', [_vm._v("Destino")]), _vm._v(" "), _c('th', [_vm._v("Distância")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Pedágios")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Agregador")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Placa")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("TAG N°")]), _vm._v(" "), _c('th', [_vm._v("Eixos")])])])
}]}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-06321eb8!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/account/aggregate/modal/toll-ticket/date-route.vue
// module id = 2041
// module chunks = 1